module.exports = __webpack_public_path__ + "img/game--madden-22--pegi.5e4b3d2d.png";